import Papa from 'papaparse';

import { BulkMarkEligibilityEmailFlagResult } from '~/services/LuxLoyalty';

import { EMAIL_FLAG_FIELD_LABELS } from './infiniteEligibilityBulkUpdate';

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizeHeader(header: string): string {
  return header
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}

export type ParsedEmailsCsv = {
  emails: Array<string>;
  invalidRows: Array<string>;
};

export function parseEmailsCsvText(csvText: string): ParsedEmailsCsv {
  const result = Papa.parse<Record<string, string>>(csvText, {
    header: true,
    skipEmptyLines: true,
    transformHeader: normalizeHeader,
  });

  const seen = new Set<string>();
  const emails: Array<string> = [];
  const invalidRows: Array<string> = [];

  result.data.forEach((row, index) => {
    const email = (row.email ?? '').trim().toLowerCase();
    if (!email) {
      return;
    }

    if (!EMAIL_REGEX.test(email)) {
      invalidRows.push(`Row ${index + 1}: Invalid email '${email}'`);
      return;
    }

    if (seen.has(email)) {
      return;
    }

    seen.add(email);
    emails.push(email);
  });

  return { emails, invalidRows };
}

export function getBulkMarkEmailFlagResultMessage(result: BulkMarkEligibilityEmailFlagResult): string {
  const flagLabel = EMAIL_FLAG_FIELD_LABELS[result.field];
  const parts = [`Marked ${flagLabel} for ${result.updatedCount} of ${result.requestedCount} email(s).`];

  if (result.alreadySetCount > 0) {
    parts.push(`${result.alreadySetCount} were already marked.`);
  }

  if (result.notFoundEmails.length > 0) {
    parts.push(`${result.notFoundEmails.length} email(s) not found: ${result.notFoundEmails.join(', ')}.`);
  }

  if (result.skippedIneligibleEmails.length > 0) {
    parts.push(
      `${result.skippedIneligibleEmails.length} skipped (no finalised application): ${result.skippedIneligibleEmails.join(', ')}.`,
    );
  }

  return parts.join(' ');
}
